import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import { TESTIMONIALS } from "../../lib/content";
import { Eyebrow } from "../Reveal";

export const Testimonials = () => (
  <section id="reviews" data-testid="testimonials" className="bg-muted py-24 md:py-32">
    <div className="mx-auto max-w-[1400px] px-6 md:px-10">
      <div className="mb-16">
        <Eyebrow>Kind words</Eyebrow>
        <h2 className="font-display text-5xl md:text-7xl font-light tracking-tight leading-[0.95] mt-4">
          Groups that
          <span className="text-primary italic"> arrived at ease.</span>
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
        {TESTIMONIALS.map((t, i) => (
          <motion.figure
            key={t.name}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: i * 0.12 }}
            className="bg-background border border-border p-8 md:p-10 flex flex-col justify-between min-h-[320px]"
          >
            <Quote className="w-9 h-9 text-primary mb-6" />
            <blockquote className="font-display text-2xl md:text-[1.7rem] font-light leading-snug flex-1">
              "{t.quote}"
            </blockquote>
            <figcaption className="mt-8 pt-6 border-t border-border">
              <div className="font-medium">{t.name}</div>
              <div className="label-eyebrow text-muted-foreground mt-1">{t.role}</div>
            </figcaption>
          </motion.figure>
        ))}
      </div>
    </div>
  </section>
);
